import React from "react";
import states from "../../../../public/locals/states.json";

export default class Location extends React.Component {
  state = {
    selectedCountry: this.props.user.address.country,
  };
  renderStateProvince = () => {
    console.log(this.state);
    return this.state.selectedCountry === "United States of America" || this.state.selectedCountry === "USA" ? (
      <div className="select">
        <select
          disabled={this.props.disabled}
          className="form-control"
          name="address_attributes[state]"
          defaultValue={this.props.user.address.state}
          value={this.state.province}
        >
          <option disabled>State</option>
          {states.map((state) => (
            <option key={state.abbreviation} value={state.abbreviation}>
              {state.name}
            </option>
          ))}
        </select>
      </div>
    ) : (
      <input
        disabled={this.props.disabled}
        onChange={(e) => this.setState({ province: e.target.value })}
        defaultValue={this.props.user.address.state}
        type="text"
        name="address_attributes[state]"
        className="form-control"
        placeholder="State"
      />
    );
  };
  render() {
    return this.props.user.address ? (
      <div className="form-row mb-5">
        <div className="col-100 col-md-25 d-flex align-items-start">
          <label className="location-mt">Location</label>
        </div>
        <div className="col-100 col-md-75">
          <div className="select">
            <select
              disabled={this.props.disabled}
              className="form-control"
              name="address_attributes[country]"
              value={this.state.selectedCountry}
              onChange={({ target: { value } }) => this.setState({ selectedCountry: value })}
            >
              {this.props.countries &&
                this.props.countries
                  .sort((a, b) => (a.name === "United States of America" ? -1 : 0))
                  .map((c) => (
                    <option key={c.alpha2Code} value={c.name}>
                      {c.name}
                    </option>
                  ))}
            </select>
          </div>
          <div className="row mt-3">
            <div className="col">{this.renderStateProvince()}</div>
          </div>
        </div>
        <div className="col-100 col-md-25 d-none d-md-flex align-items-start"></div>
        <div className="col-100 col-md-75">
          <div className="row mt-3">
            <div className="col-60">
              <input
                disabled={this.props.disabled}
                defaultValue={this.props.user.address.city}
                type="text"
                name="address_attributes[city]"
                className="form-control text-capitalize"
                placeholder="City"
              />
            </div>
            <div className="col-40">
              <input
                disabled={this.props.disabled}
                defaultValue={this.props.user.address.zip}
                type="text"
                name="address_attributes[zip]"
                className="form-control text-capitalize"
                placeholder="Zip"
              />
            </div>
          </div>
        </div>
        <div className="col-100 col-md-25 d-none d-md-flex align-items-start"></div>
        <div className="col-100 col-md-75">
          <div className="row mt-3">
            <div className="col">
              <input
                disabled={this.props.disabled}
                defaultValue={this.props.user.address.address_1}
                type="text"
                name="address_attributes[address1]"
                className="form-control text-capitalize"
                placeholder="Address 1"
              />
            </div>
          </div>
        </div>
        <div className="col-100 col-md-25 d-none d-md-flex align-items-start"></div>
        <div className="col-100 col-md-75">
          <div className="row mt-3">
            <div className="col">
              <input
                disabled={this.props.disabled}
                defaultValue={this.props.user.address.address_2}
                type="text"
                name="address_attributes[address2]"
                className="form-control text-capitalize"
                placeholder="Address 2"
              />
            </div>
          </div>
        </div>
        <div className="col-25 d-flex align-items-start"></div>
      </div>
    ) : null;
  }
}
